/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPickerModel, IRListItem } from '@rhybus/api'
import React, { useContext, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { mpfWhoHttp } from '../../../../assets/ts/api/mpf-who-http'
import { COMPONENTS_CODE } from '../../../../assets/ts/data/common-metadata'
import { PascodeMetadata } from '../../../../assets/ts/data/pascode-metadata'
import {
  UserProfile,
  LIST_NAME as UserprofileListName,
} from '../../../../assets/ts/data/user-profile'
import {
  UserProfileView,
} from '../../../../assets/ts/data/user-profile-view'
import {
  filterRank,
  formatPhoneNumber,
  isChangeDetected,
} from '../../../../assets/ts/general/general'
import { isDODValid, isDropDownValid, isMatch, isPhoneNumberValid } from '../../../../assets/ts/validations/validations'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_VALUE_STRING,
  MAX_LENGTHS,
  SELECT_OPTION_STRING,
} from '../../../../utils/constants/global-constants'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputCheckbox from '../../../../utils/controls/input-checkbox'
import InputText from '../../../../utils/controls/input-text'
import { ProfileItems } from './userprofiles'

interface ProfileInputs {
  AssignedComponentCode: number
  CustomerId: string
  CustomerStatus: string
  DoDNumber: string
  DutyEmail: string
  DutyPhone: string
  IsValidDutyEmail: boolean
  IsValidLocation: boolean
  IsValidOrganization: boolean
  IsValidPASCODE: boolean
  Location: string
  OrgMAJCOM: string
  Organization: string
  PASCODE: string
  Rank: string
  ServicingBy?: string
  ServicingMajcom?: string
  ServicingOrganization?: string
  UserDisplayName?: string
}
interface Props {
  cancel: () => void
  clickedIndex?: number
  listModified: boolean
  profile?: ProfileItems
  setListModified: React.Dispatch<React.SetStateAction<boolean>>
  showAddPopup?: boolean
  showEdit?: boolean
  userProfile: UserProfile[] | UserProfileView[]
}
interface ProfileValidation {
  DodId: boolean
  DodIdMsg: string
  DutyEmail: boolean
  DutyEmailMsg: string
  DutyPhone: boolean
  Location: boolean
  Organization: boolean
  PASCODE: boolean
  PASCODEMsg: string
  Rank: boolean
  Status: boolean
}
const AddEditView = ({
  cancel,
  clickedIndex,
  listModified,
  profile,
  setListModified,
  showAddPopup,
  showEdit,
  userProfile,
}: Props) => {
  const [showNochanges, setShowNochanges] = useState(false)
  const intialValidation: ProfileValidation = {
    DodId: false,
    DodIdMsg: '',
    DutyEmail: false,
    DutyEmailMsg: '',
    DutyPhone: false,
    Location: false,
    Organization: false,
    PASCODE: false,
    PASCODEMsg : '',
    Rank: false,
    Status: false,
  }
  const [validation, setValidation] =
    useState<ProfileValidation>(intialValidation)
  const { components, pascodeMetadata, ranks } = useContext(MetadataContext)
  const profileintialInputs: ProfileInputs = {
    AssignedComponentCode: COMPONENTS_CODE.Regular_Air_Force,
    CustomerId: '',
    CustomerStatus: '',
    DoDNumber: '',
    DutyEmail: '',
    DutyPhone: '',
    IsValidDutyEmail: false,
    IsValidLocation: true,
    IsValidOrganization: true,
    IsValidPASCODE: false,
    Location: '',
    OrgMAJCOM: '',
    Organization: '',
    PASCODE: '',
    PascodeID: -1,
    Rank: '',
    ServicingBy: '',
    ServicingMajcom: '',
    ServicingOrganization: '',
    UserDisplayName: '',
  }
  const [matchError, setMatchError] = useState({
    Installation: true,
    Organization: true,
    PASCODE: true,
  })
  const [organizationDropDown, setOrganizationDropDown] = useState<
    Array<string>
  >([])
  const [pascodeDropDown, setPascodeDropDown] = useState<Array<string>>([])
  const [peopleDropdownEmails, setPeopleDropdownEmails] = useState<string[]>([])
  const [inputs, setInputs] = useState<ProfileInputs>(profileintialInputs)
  const [disableDODorDutymail, setDisableDODorDutymail] = useState<
    'dod' | 'dutymail' | null
  >(null)
  const [isPasCodeKnown, setIsPasCodeKnown] = useState<boolean>(true)
  const [showEditFields, setShowEditFields] = useState({
    location: false,
    organization: false,
    pasCode: true,
  })
  const [existingProfile, setexistingProfile] = useState<ProfileInputs>()
  const [showReadonlyFields, setShowReadonlyFields] = useState<boolean>(false)
  const [assignedLocationDropDown, setAssignedLocationDropDown] = useState<
    Array<string>
  >([])
  const [statusOptions, setStatusOptions] = useState([SELECT_OPTION_STRING])
  const [rankOptions, setRankOptions] = useState([SELECT_OPTION_STRING])
  const [userList, setuserList] = useState<Array<IPickerModel>>([])
  const [matchedCustomerPascode, setMatchedCustomerPascode] = useState<
    Array<PascodeMetadata>
  >([])
  const titleRef: any = useRef<any>(null)
  const descriptionRef = useRef<any>(null)
  const resetFields = (changeinput: string, value: string) => {
    setShowReadonlyFields(false)
    setShowEditFields((prev) => ({
      ...prev,
      location: changeinput === 'Location' || changeinput === 'Organization',
      organization: changeinput === 'Organization',
      pasCode:
        changeinput === 'PASCODE' ||
        changeinput === 'DutyEmail' ||
        changeinput === 'Dod',
    }))
    if (changeinput === 'DutyEmail' || changeinput === 'Dod') {
      setIsPasCodeKnown(true)
    }
    setInputs((prev) => ({
      ...prev,
      AssignedComponentCode:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? profileintialInputs.AssignedComponentCode
          : prev.AssignedComponentCode,
      CustomerStatus:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? profileintialInputs.CustomerStatus
          : prev.CustomerStatus,
      DoDNumber:
        changeinput === 'DutyEmail'
          ? profileintialInputs.DoDNumber
          : changeinput === 'Dod'
          ? value
          : prev.DoDNumber,
      DutyEmail:
        changeinput === 'DutyEmail'
          ? value
          : changeinput === 'Dod'
          ? profileintialInputs.DutyEmail
          : prev.DutyEmail,
      DutyPhone:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? profileintialInputs.DutyPhone
          : prev.DutyPhone,
      IsValidLocation:
        !showEditFields.location || changeinput === 'Organization',
      IsValidOrganization: !showEditFields.organization,
      IsValidPASCODE: !isPasCodeKnown,
      Location:
        changeinput === 'Location'
          ? value
          : changeinput === 'Organization'
          ? prev.Location
          : '',
      OrgMAJCOM: '',
      Organization: changeinput === 'Organization' ? value : '',
      PASCODE: changeinput === 'PASCODE' ? value : '',
      PascodeID: -1,
      Rank:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? profileintialInputs.Rank
          : prev.Rank,
      ServicingBy: '',
      ServicingOrganization: '',
    }))
  }
  useEffect(() => {
    if (profile) {
      const editInputs: ProfileInputs = {
        AssignedComponentCode: profile.assignedComponentCode,
        CustomerId: profile.userRid,
        CustomerStatus: profile.profileStatus,
        DoDNumber: profile.DODIDnumber,
        DutyEmail: profile.dutyEmail,
        DutyPhone: profile.dutyPhone,
        IsValidDutyEmail: true,
        IsValidLocation: true,
        IsValidOrganization: true,
        IsValidPASCODE: true,
        Location: profile.installation,
        OrgMAJCOM: profile.orgMAJCOM,
        Organization: profile.organization,
        PASCODE: profile.PASCODE,
        PascodeID: profile.PascodeID,
        Rank: profile.rank,
        ServicingBy: profile.PASCODEServiceBy,
        ServicingMajcom: profile.servicingMAJCOM,
        ServicingOrganization: profile.servicingOrganaization,
        UserDisplayName: profile.userDisplayName,
      }
      generateStatusOption(profile.assignedComponentCode)
      generateRankOptions(profile.profileStatus, profile.assignedComponentCode)
      setShowReadonlyFields(true)
      setShowEditFields((prev) => ({
        ...prev,
        location: true,
        organization: true,
        pasCode: true,
      }))
      setexistingProfile(editInputs)
      setInputs(editInputs)
    }
  }, [profile])
   useEffect(() =>{
    const titleElemnt = document.getElementById('DoDNumber')
    if(titleRef?.current && titleElemnt){
      if(clickedIndex === 0){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'end'})
        titleElemnt.focus()
      }else if(clickedIndex === 1){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'nearest'})
        titleElemnt.focus()
      }else{
        titleRef?.current?.scrollIntoView(false)
        titleElemnt.focus()
      }
    }
  }, [titleRef, showEdit, descriptionRef])
  function generateRankOptions(status: string, assignComponenetCode: number) {
    const filteredGrades = filterRank(status, ranks, assignComponenetCode)
    const rankOptions =
      filteredGrades.length === 1
        ? filteredGrades
        : [SELECT_OPTION_STRING, ...filteredGrades]
    setRankOptions(rankOptions)
    return rankOptions
  }
  useEffect(() => {
    const orgPASCODE = pascodeMetadata.filter(
      (item) =>
        Number(item.AssignedComponentCode) === inputs.AssignedComponentCode
    )
    setMatchedCustomerPascode(orgPASCODE)
  }, [pascodeMetadata, inputs.AssignedComponentCode])
  useEffect(() => {
    const assignedlocations = [
      ...new Set(
        matchedCustomerPascode.map(({ Installation }) => {
          return Installation
        })
      ),
    ].filter((item) => item !== undefined)
    const pascodes = [
      ...new Set(
        matchedCustomerPascode.map(({ PASCODE }) => {
          return PASCODE
        })
      ),
    ].filter((item) => item !== undefined)
    setAssignedLocationDropDown(assignedlocations)
    setPascodeDropDown(pascodes)
  }, [matchedCustomerPascode])
  const onChangeDODNumber = async (e: {
    target: { id: string; value: string }
  }) => {
    const { id, value } = e.target
    const numbersOnly = /^[0-9\b]+$/
    setValidation(intialValidation)
    if (value === '' || (numbersOnly.test(value) && value.length < 11)) {
      setInputs((prev) => ({
        ...prev,
        [id]: value,
      }))
      setDisableDODorDutymail(null)
      resetFields('Dod', value)
    }
    if (value.length === 10) {
      const loginDetails = userProfile.find((item) => item.DoDNumber === value)
      if (loginDetails) {
        setInputs((prev) => ({
          ...prev,
          DoDNumber: '',
        }))
        setValidation((prev) => ({
          ...prev,
          DodId: true,
          DodIdMsg: 'Entered DODID already given for the existing profiles',
        }))
      } else {
        const userList = [...(await mpfWhoHttp().Other(value.trim()))]
        const user = userList.find((item) => item.edipi === value)
        if (user) {
          setDisableDODorDutymail('dutymail')
          updateCustomerDetails(user)
        }
      }
    }
  }
  const updateCustomerDetails = (user: IPickerModel) => {
    setInputs((prev) => ({
      ...prev,
      CustomerId: user.rid,
      DoDNumber: user.edipi,
      DutyEmail: user.email,
      IsValidDutyEmail : true,
      UserDisplayName: user.persona,
    }))
  }
  const componentsOptions = components.map((component) => ({
    label: component.Component,
    value: component.ComponentCode,
  }))
  const onChangeAssignedComponent = (e: { label: string; value: number }) => {
    const newState : Partial <ProfileInputs> = {
      AssignedComponentCode: e.value,
      CustomerStatus: ALL_SELECT_VALUE_STRING,
      IsValidPASCODE : false,
      Location: '',
      OrgMAJCOM: '',
      Organization: '',
      PASCODE: '',
      PascodeID: -1,
      Rank: ALL_SELECT_VALUE_STRING,
      ServicingBy: '',
      ServicingMajcom: '',
      ServicingOrganization: '',
    }
    setInputs((prevState) => ({
      ...prevState,
      ...newState,
    }))
    setIsPasCodeKnown(true)
    setShowReadonlyFields(false)
    setShowEditFields({
      location: false,
      organization: false,
      pasCode: true,
    })
    generateStatusOption(e.value)
    setRankOptions([SELECT_OPTION_STRING])
  }
  useEffect(() => {
    if (!profile) {
      generateStatusOption(inputs.AssignedComponentCode)
      setRankOptions([SELECT_OPTION_STRING])
    }
  }, [ranks])
  const generateStatusOption = (assignComponenetCode: number) => {
    const profileStatus = [
      ...new Set(
        ranks
          ?.filter(
            (assCom) => assCom.AssignedComponentCode === assignComponenetCode
          )
          .map(({ Status }) => {
            return Status
          })
      ),
    ].map((rank) => {
      return { label: rank, value: rank }
    })
    setStatusOptions([SELECT_OPTION_STRING, ...profileStatus])
  }
  function onChangeStatus(e: { label: string; value: string }) {
    const filteredGrades = generateRankOptions(
      e.value,
      inputs.AssignedComponentCode
    )
    setInputs((prev) => ({
      ...prev,
      CustomerStatus: e.value,
      Rank: filteredGrades.length === 1 ? filteredGrades[0].value : '',
    }))
  }
  function onChangeRank(e: { label: string; value: string }) {
    setInputs((prev) => ({
      ...prev,
      Rank: e.value,
    }))
  }
  const onChangeUser = async (value: string) => {
    setValidation(intialValidation)
    setInputs((prev) => ({
      ...prev,
      DutyEmail: value,
    }))
    resetFields('DutyEmail', value)
    setDisableDODorDutymail(null)
    if (value.trim().length > 2) {
      const userList = [...(await mpfWhoHttp().Picker(value.trim()))]
      setuserList(userList)
      const userName = userList.map((item) => item.email)
      setPeopleDropdownEmails(userName)
    }
  }

  const selectedUser = async (value: string) => {
    const loginDetails = userProfile.find((item) => item.DutyEmail === value)
    if (loginDetails) {
      setInputs((prev) => ({
        ...prev,
        DutyEmail: '',
      }))
      setValidation((prev) => ({
        ...prev,
        DutyEmail: true,
        DutyEmailMsg: 'Entered Email already given for the existing profiles',
      }))
    } else {
      setDisableDODorDutymail('dod')
      const user = userList.find((item) => item.email === value) as IPickerModel
      updateCustomerDetails(user)
    }
  }
  const onChangePhoneNumber = (e: {
    target: { id: string; value: string }
  }) => {
    const { value } = e.target
    const numbersOnly = /^[0-9\b]+$/
    const numbersWithSymbolsAndSpace = /^[0-9()\b\s-]+$/
    if (value === '' || (numbersOnly.test(value) && value.length < 11)) {
      setInputs((prev) => ({
        ...prev,
        DutyPhone: value,
      }))
    }
    if (numbersWithSymbolsAndSpace.test(value) && value.length === 13) {
      const output = value.slice(0, -1).replace(/[^\d]/g, '')
      setInputs((prev) => ({
        ...prev,
        DutyPhone: output,
      }))
    }
  }
  function knowPascode(e: { target: { value: string } }) {
    const { value } = e.target
    setIsPasCodeKnown(value === 'Yes' ? true : false)
    setShowEditFields((prev) => ({
      ...prev,
      location: value === 'Yes' ? false : true,
      organization: false,
      pasCode: value === 'Yes' ? true : false,
    }))
    setShowReadonlyFields(false)
    setInputs((prev) => ({
      ...prev,
      IsValidLocation: value === 'Yes' ? true : false,
      IsValidOrganization: true,
      IsValidPASCODE: value === 'Yes' ? false : true,
      Location: '',
      OrgMAJCOM: '',
      Organization: '',
      PASCODE: '',
      PascodeID: -1,
      ServicingBy: '',
      ServicingOrganization: '',
    }))
  }
  const onChangeOrganization = (e: {
    target: { id: string; value: string }
  }) => {
    if (
      e.target.value.length > 2 &&
      !isMatch(organizationDropDown, e.target.value)
    ) {
      setMatchError({ ...matchError, Organization: false })
    } else {
      setMatchError({ ...matchError, Organization: true })
    }
    resetFields(e.target.id, e.target.value)
    setInputs((prev) => ({
      ...prev,
      Organization: e.target.value,
    }))
  }
  const selectOrganization = (organization: string) => {
    customerOrgDetails(undefined, organization)
    setShowEditFields((prev) => ({
      ...prev,
      pasCode: true,
    }))
  }
  const customerOrgDetails = (
    pascode?: string | undefined,
    organization?: string
  ) => {
    const {
      Code,
      Installation,
      OrgMAJCOM,
      Organization,
      PASCODE,
      ServicingBy,
      ServicingMAJCOM,
      ServicingOrganization,
    } = pascode
      ? matchedCustomerPascode.find(({ PASCODE }) => PASCODE === pascode) ?? {}
      : matchedCustomerPascode.find(
          ({ Organization }) => Organization === organization
        ) ?? {}

    setInputs((prev) => ({
      ...prev,
      IsValidLocation: true,
      IsValidOrganization: true,
      IsValidPASCODE: true,
      Location: Installation as string,
      OrgMAJCOM: OrgMAJCOM as string,
      Organization: Organization as string,
      PASCODE: PASCODE as string,
      PascodeID: Code as number,
      ServicingBy: ServicingBy as string,
      ServicingMajcom: ServicingMAJCOM as string,
      ServicingOrganization: ServicingOrganization as string,
    }))
    setShowReadonlyFields(true)
  }
  const selectPASCODE = (pascode: string) => {
    customerOrgDetails(pascode)
    setShowEditFields((prev) => ({
      ...prev,
      location: true,
      organization: true,
    }))
  }
  const changePASCODE = (e: { target: { id: string; value: string } }) => {
    if (
      e.target.value.length > 2 &&
      !isMatch(pascodeDropDown, e.target.value)
    ) {
      setMatchError({ ...matchError, PASCODE: false })
    } else {
      setMatchError({ ...matchError, PASCODE: true })
    }

    if (e.target.value.length < 9) {
      resetFields(e.target.id, e.target.value)

      setInputs((prev) => ({
        ...prev,

        PASCODE: e.target.value,
      }))
    }
  }
  const selectLocation = (location: string) => {
    setShowEditFields((prev) => ({
      ...prev,
      organization: true,
    }))
    const orgPASCODE = matchedCustomerPascode.filter(
      (item) => item.Installation === location
    )
    const organizations = [
      ...new Set(
        orgPASCODE.map(({ Organization }) => {
          return Organization
        })
      ),
    ].filter((item) => item !== undefined)
    setOrganizationDropDown(organizations)
    setInputs((prev) => ({
      ...prev,
      IsValidLocation: true,
      IsValidOrganization: false,
      IsValidPASCODE: true,
      Location: location,
    }))
  }
  const changeLocation = (e: { target: { id: string; value: string } }) => {
    if (
      e.target.value.length > 2 &&
      !isMatch(assignedLocationDropDown, e.target.value)
    ) {
      setMatchError({ ...matchError, Installation: false })
    } else {
      setMatchError({ ...matchError, Installation: true })
    }
    resetFields(e.target.id, e.target.value)
    setInputs((prev) => ({
      ...prev,
      Location: e.target.value,
    }))
  }

  const validateUserProfile = () => {
    const isValid = {
      DoDNumber: !isDODValid(inputs.DoDNumber) || !inputs.IsValidDutyEmail,
      DutyEmail: !inputs.IsValidDutyEmail,
      DutyPhone: !isPhoneNumberValid(inputs.DutyPhone),
      Location: !inputs.IsValidLocation,
      Organization: !inputs.IsValidOrganization,
      PASCODE: !inputs.IsValidPASCODE,
      Rank: !isDropDownValid(inputs.Rank),
      Status: !isDropDownValid(inputs.CustomerStatus),
    }
    let isAnyInvalid = Object.values(isValid).includes(true)
    setValidation((prev) => ({
      ...prev,
      DodId: isValid.DoDNumber,
      DodIdMsg: isValid.DoDNumber ? 'Please enter valid DoD ID Number' : '',
      DutyEmail: isValid.DutyEmail,
      DutyEmailMsg: isValid.DutyEmail ? 'Please enter valid Duty email' : '',
      DutyPhone: isValid.DutyPhone,
      Location: isValid.Location,
      Organization: isValid.Organization,
      PASCODE: isValid.PASCODE,
      PASCODEMsg: isValid.PASCODE ?'Please enter valid PASCODE':'',
      Rank: isValid.Rank,
      Status: isValid.Status,
    }))

    if (profile && !isChangeDetected(existingProfile, inputs)) {
      setShowNochanges(true)
      isAnyInvalid = true
    }
    if (!isAnyInvalid) saveProfile()
  }
  const saveProfile = async () => {
    const userdetails = mpfRListsHttp().me()
    const userId = (await userdetails).userId
    const userProfileObj = {
      AssignedComponentCode: inputs.AssignedComponentCode,
      DoDNumber: inputs.DoDNumber,
      DutyEmail: inputs.DutyEmail,
      DutyPhone: inputs.DutyPhone,
      IsArchived: false,
      ItemCreated: new Date(),
      ItemCreatedBy: userId,
      ItemModified: new Date(),
      ItemModifiedBy: userId,
      PascodeID: inputs.PascodeID,
      ProfileStatus: inputs.CustomerStatus,
      Rank: inputs.Rank,
      UserDisplayName: inputs?.UserDisplayName,
      UserRID: inputs?.CustomerId,
    }
    if (profile && profile.ItemKey !== '') {
      userProfileObj['eKey'] = profile.ItemKey
      userProfileObj['eTag'] = profile.eTag
      userProfileObj['ItemModified'] = new Date()
      userProfileObj['ItemModifiedBy'] = userId
    }

    try {
      const profileList = await mpfRListsHttp().getList(UserprofileListName)
      await profileList.addOrUpdateItem(userProfileObj as IRListItem)
      cancel()
      setListModified(!listModified)
      //onSubmitSuccess()
    } catch (error) {
      console.error(error)
    }
  }
  const nochangesAlert = () => {
    setShowNochanges(false)
  }
  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative border-top1 mt-2'
      }
      id='scroll'
    >
      {showAddPopup && (
        <div className='p-3 border-bottom4'>
          <h4
            aria-label='Add People'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add People
          </h4>
        </div>
      )}
      {showNochanges && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={'No Changes Detected'}
          onClick={nochangesAlert}
          yes='OK'
        />
      )}
      <div className='px-2 py-1'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='p-0 w-100'>
              <h3
                aria-label='Personal Details '
                className='text-uppercase color-primary poppins-semibold font-12 d-inline-block m-0'
                tabIndex={0}
              >
                Personal Details
              </h3>
            </div>
          </div>
          <div
            className={
              showAddPopup
                ? 'col-12 col-sm-6 col-lg-4 mb-2'
                : 'col-12 col-sm-6 col-lg-4 mb-2'
            }
            ref={titleRef}
          >
            <InputText
              changeHandler={onChangeDODNumber}
              className='form-lg font-13 sourcesanspro'
              disabled={
                disableDODorDutymail === 'dod' || profile ? true : false
              }
              errorMessage={validation.DodId}
              formClassName=' form-vertical'
              info='DoD ID Number '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'font-12 poppins-medium title-color2 mb-1',
                id: 'DoDNumber',
                maxLength: '10',
                name: 'DoD ID Number',
                placeholder: 'DoD ID Number',
                value: inputs?.DoDNumber,
              }}
              isInfo
              isMandatory
              label='DoD ID Number'
              msg={validation.DodIdMsg}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-12 col-sm-6 col-lg-4 mb-2'
                : 'col-12 col-sm-6 col-lg-4 mb-2'
            }
            ref={descriptionRef}
          >
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
              formClassName='form-vertical'
              id='AssignedComponent'
              info='AssignedComponent'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Assigned Component'
              name='Assigned Component'
              onChange={onChangeAssignedComponent}
              options={componentsOptions}
              value={inputs.AssignedComponentCode}
            />
          </div>

          <div
            className={
              showAddPopup
                ? 'col-12 col-sm-6 col-lg-4 mb-2'
                : 'col-12 col-sm-6 col-lg-4 mb-2'
            }
          >
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
              error={validation.Status}
              formClassName='form-vertical text-nowrap'
              id='ProfileStatus'
              info='Status'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Status'
              name='Status'
              onChange={onChangeStatus}
              options={statusOptions}
              value={inputs.CustomerStatus}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-12 col-sm-6 col-lg-4 mb-2'
                : 'col-12 col-sm-6 col-lg-4 mb-2'
            }
          >
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
              error={validation.Rank}
              formClassName='form-vertical text-nowrap'
              id='ProfileRank'
              info='Rank'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Rank'
              name='Rank'
              onChange={onChangeRank}
              options={rankOptions}
              value={inputs.Rank}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-12 col-sm-6 col-lg-4 mb-2'
                : 'col-12 col-sm-6 col-lg-4 mb-2'
            }
          >
            <InputText
              changeHandler={(e) => {
                onChangeUser(e.target.value)
              }}
              className='form-lg font-13 sourcesanspro'
              data={peopleDropdownEmails}
              disabled={
                disableDODorDutymail === 'dutymail' || profile ? true : false
              }
              errorMessage={validation.DutyEmail}
              formClassName=' form-vertical'
              info='Duty Email'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'font-12 poppins-medium title-color2 mb-1',
                id: 'DutyEmail',
                maxLength: '250',
                name: 'Duty Email',
                placeholder: 'james.jones@us.af.mil',
              }}
              isInfo
              isMandatory
              label='Duty Email'
              msg={validation.DutyEmailMsg}
              onSelect={selectedUser}
              type='peopel-picker'
              value={inputs.DutyEmail}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-12 col-sm-6 col-lg-4  mb-2'
                : 'col-12 col-sm-6 col-lg-4  mb-2'
            }
          >
            <InputText
              changeHandler={onChangePhoneNumber}
              className='form-lg font-13 sourcesanspro'
              error={validation.DutyPhone}
              formClassName=' form-vertical'
              info='Duty Phone'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'font-12 poppins-medium title-color2 mb-1',
                id: 'DutyPhone',
                maxLength: '250',
                name: 'Duty Phone',
                placeholder: '(000) 000-0000',
                value: formatPhoneNumber(inputs.DutyPhone),
              }}
              isInfo
              isMandatory
              label='Duty Phone'
            />
          </div>

          <div className='p-2 w-100'>
            <h3
              aria-label='Organizational Details '
              className='text-uppercase color-primary poppins-semibold font-12 d-inline-block m-0'
              tabIndex={0}
            >
              Organizational Details{' '}
            </h3>
          </div>

          <div className=' row align-item-end mt-0 userprofileorgfeilds'>
            <div className='mb-2 col-12 col-sm-6 col-lg-4 d-flex flex-column align-items-start justify-content-end pascodeinfo'>
              <div className='pb-7'>
                <label
                  className='font-12 poppins-medium title-color2 form-horztional'
                  htmlFor='Do you know the PASCODE?'
                >
                  Do You Know The Unit PASCODE?{' '}
                  <span className='mandatory me-1'>*</span>
                  <span
                    className='tool-tip tooltip-bottom font-12 sourcesanspro'
                    data-tip='Do You Know The Unit PASCODE?'
                  >
                    <span className='icon-info color-primary'></span>
                  </span>
                </label>
              </div>
              <div className='d-flex align-items-center'>
                <InputCheckbox
                  formClassName='d-flex align-items-center'
                  inputProps={{
                    arialabel: 'Yes',
                    checked: isPasCodeKnown,
                    className: 'font-12 poppins-medium title-color2 mx-2',
                    id: 'YesRadio',
                    label: 'Yes',
                    name: 'Pascoderadio',
                    type: 'radio',
                    value: 'Yes',
                  }}
                  onChange={knowPascode}
                />
                <InputCheckbox
                  formClassName='d-flex align-items-center'
                  inputProps={{
                    arialabel: 'No',
                    checked: !isPasCodeKnown,
                    className: 'font-12 poppins-medium title-color2 mx-2',
                    id: 'NoRadio',
                    label: 'No',
                    name: 'Pascoderadio',
                    type: 'radio',
                    value: 'No',
                  }}
                  onChange={knowPascode}
                />
              </div>
            </div>
            {showReadonlyFields &&
              inputs?.AssignedComponentCode ===
                COMPONENTS_CODE.Regular_Air_Force && (
                <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-20per mt-2'>
                  <InputText
                    className='form-lg font-13 sourcesanspro'
                    disabled
                    formClassName=' form-vertical'
                    info='MAJCOM/DRU/FOA'
                    infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'font-12 poppins-medium title-color',
                      id: 'OrganizationMAJCOM',
                      maxLength: '250',
                      name: 'MAJCOM/DRU/FOA',
                      placeholder: 'MAJCOM/DRU/FOA',
                      value: inputs.OrgMAJCOM,
                    }}
                    isInfo
                    label='MAJCOM/DRU/FOA'
                  />
                </div>
              )}
            {showEditFields.location && (
              <div className='mb-2 col-12 col-sm-6 col-lg-4'>
                <InputText
                  changeHandler={changeLocation}
                  className='form-lg font-13 sourcesanspro'
                  data={assignedLocationDropDown}
                  disabled={isPasCodeKnown}
                  error={!matchError.Installation || validation.Location}
                  formClassName=' form-vertical'
                  info='What is your Assigned Location?'
                  infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className: 'font-12 poppins-medium title-color2 mb-1',
                    id: 'Location',
                    maxLength: '250',
                    name: 'What is your Assigned Location?',
                    placeholder: 'Assigned Location',
                  }}
                  isInfo
                  isMandatory
                  label='What is your Assigned Location?'
                  onSelect={selectLocation}
                  value={inputs.Location}
                />
              </div>
            )}
            {showEditFields.organization && (
              <div className='mb-2 col-12 col-sm-6 col-lg-4'>
                <InputText
                  changeHandler={onChangeOrganization}
                  className='form-lg font-13 sourcesanspro'
                  data={organizationDropDown}
                  disabled={isPasCodeKnown}
                  error={!matchError.Organization || validation.Organization}
                  formClassName=' form-vertical'
                  info='What is your Organization'
                  infoClassName='tool-tip tooltip-left font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className:
                      'font-12 poppins-medium title-color2 mb-1 text-nowrap',
                    id: 'Organization',
                    maxLength: '250',
                    name: 'What is your Organization',
                    placeholder: 'Test Org MPF',
                  }}
                  isInfo
                  isMandatory
                  label='What is your Organization'
                  onSelect={selectOrganization}
                  value={inputs.Organization}
                />
              </div>
            )}

            {showReadonlyFields && (
              <div className='mb-2 col-12 col-sm-6 col-lg-4'>
                <InputText
                  className='form-lg font-13 sourcesanspro'
                  disabled
                  formClassName=' form-vertical'
                  info='PASCODE Serviced By'
                  infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className: 'font-12 poppins-medium title-color2 mb-1',
                    id: 'ServicedBy',
                    maxLength: '250',
                    name: 'PASCODE Serviced By',
                    placeholder: 'MPF',
                    value: inputs.ServicingBy,
                  }}
                  isInfo
                  label='PASCODE Serviced By'
                />
              </div>
            )}
            {showReadonlyFields && (
              <div className='mb-2 col-12 col-sm-6 col-lg-4'>
                <InputText
                  className='form-lg font-13 sourcesanspro'
                  disabled
                  formClassName=' form-vertical'
                  info='Servicing Organization'
                  infoClassName='tool-tip tooltip-left font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className: 'font-12 poppins-medium title-color2 mb-1',
                    id: 'ServicingOrganization',
                    maxLength: '250',
                    name: 'Servicing Organization',
                    placeholder: '96MPF',
                    value: inputs.ServicingOrganization,
                  }}
                  isInfo
                  label='Servicing Organization'
                />
              </div>
            )}
            {showReadonlyFields && (
              <div className='mb-2 col-12 col-sm-6 col-lg-4'>
                <InputText
                  className='form-lg font-13 sourcesanspro'
                  disabled
                  formClassName='form-vertical'
                  info='Servicing Majcom'
                  infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className: 'font-12 poppins-medium title-color mb-1',
                    id: 'ServicingMAJCOM',
                    maxLength: '250',
                    name: 'Servicing MAJCOM',
                    value: inputs.ServicingMajcom,
                  }}
                  isInfo
                  label='Servicing MAJCOM'
                />
              </div>
            )}
            {showEditFields.pasCode && (
              <div className='mb-2 col-12 col-sm-6 col-lg-4'>
                <InputText
                  changeHandler={changePASCODE}
                  className='form-lg font-13 sourcesanspro'
                  data={pascodeDropDown}
                  disabled={!isPasCodeKnown}
                  error={!matchError.PASCODE}
                  errorMessage={validation.PASCODE}
                  formClassName=' form-vertical'
                  info='PASCODE'
                  infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className: 'font-12 poppins-medium title-color2 mb-1',
                    id: 'PASCODE',
                    maxLength: MAX_LENGTHS.EIGHT,
                    name: 'PASCODE',
                    placeholder: 'ED06F70B',
                  }}
                  isInfo
                  isMandatory
                  label='PASCODE'
                  maxLength={8}
                  msg={validation.PASCODEMsg}
                  onSelect={selectPASCODE}
                  value={inputs.PASCODE}
                />
              </div>
            )}
          </div>
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={() => {
                    validateUserProfile()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={() => {
                    validateUserProfile()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
